import React from 'react';
import { Plus, Check } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import ImageCarousel from './ImageCarousel';

const ProductCard = ({ product, onAddToCart, isInCart }) => {
  return (
    <Card className="network-card product-card">
      <div className="product-image-wrapper">
        <ImageCarousel images={product.images} productName={product.name} />
        <div className="product-icon">{product.icon}</div>
      </div>
      <CardContent className="product-content">
        <h3 className="product-title">{product.name}</h3>
        <p className="product-description">{product.description}</p>
        
        <ul className="product-benefits">
          {product.benefits.map((benefit, index) => (
            <li key={index}>
              <span className="benefit-dot">•</span>
              {benefit}
            </li>
          ))}
        </ul>

        <div className="product-footer">
          <div className="product-price">
            <span className="price-amount">₹{product.price}</span>
          </div>
          <button 
            className={`btn-add-cart ${isInCart ? 'in-cart' : ''}`}
            onClick={() => onAddToCart(product)}
          >
            {isInCart ? (
              <>
                <Check size={18} />
                Added
              </>
            ) : (
              <>
                <Plus size={18} />
                Add to Cart
              </>
            )}
          </button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProductCard;